import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_h5gjyp96qt: FaireBrandEntity = {
  token: "b_h5gjyp96qt",
  type: "brand",
  name: "Majestic mailers",
  avatarUrl:
    "https://cdn.faire.com/fastly/79260407b3ed6a1da27aace91e7179d4849950da263963396589de67c6be5f48.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c9175632f283771a9abdeb7189d408b2d0c05fa02c4af4a2fe2c50f1e6fc8aa3.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/79260407b3ed6a1da27aace91e7179d4849950da263963396589de67c6be5f48.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c9175632f283771a9abdeb7189d408b2d0c05fa02c4af4a2fe2c50f1e6fc8aa3.jpeg",
  location: "Chico, CA, USA",
  minimumOrderDollars: 50,
  rating: 4.8,
  reviewCount: 121,
  isTopShop: true,
  isInsider: true,
  description:
    "We are a small family owned business based in Northern California. We have fun exclusive designed poly mailers and sublimation tumblers.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:43.563Z",
    importedBy: "entity-db-cli",
  },
};
